import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableHead,
  Typography,
} from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  StyledCell,
  StyledRow,
} from "../../styled-components/styledTableComponents";

export function ShowGroupHistoryModal() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const cardTypes = useSelector((state: any) => state.cardTypes.cardTypes);

  const events = [
    { id: "GROUP_PERSON", name: t("getLogs.events.groupPerson") },
    { id: "UNGROUP_PERSON", name: t("getLogs.events.ungroupPerson") },
  ];

  const getNameFromActionType = (actionType: string) => {
    const type = events.find((e) => e.id === actionType);
    if (type) {
      return type.name;
    }
  };

  function Head() {
    return (
      <TableHead sx={{ display: "table-header-group" }}>
        <StyledRow>
          <StyledCell sx={{ fontWeight: "bold" }}>{t("date")}</StyledCell>
          <StyledCell sx={{ fontWeight: "bold" }}>
            {t("getLogs.action")}
          </StyledCell>
          <StyledCell sx={{ fontWeight: "bold" }}>{t("cardNumber")}</StyledCell>
          <StyledCell sx={{ fontWeight: "bold" }}>{t("cardType")}</StyledCell>
          <StyledCell sx={{ fontWeight: "bold" }}>
            {t("carePrincipal")}
          </StyledCell>
        </StyledRow>
      </TableHead>
    );
  }

  function Row(props: { action: any }) {
    const { action } = props;

    return (
      <Fragment>
        <StyledRow>
          <StyledCell>
            {action.logStorageDate.toLocaleDateString("sv")}
          </StyledCell>
          <StyledCell>{getNameFromActionType(action.actionType)}</StyledCell>
          <StyledCell>{action.cardId}</StyledCell>
          <StyledCell>
            {cardTypes.find((x: any) => x.id === action.cardTypeId).name}
          </StyledCell>
          <StyledCell>{action.carePrincipalId}</StyledCell>
        </StyledRow>
      </Fragment>
    );
  }

  const groupForPerson = useSelector(
    (state: any) => state.person.groupForPerson
  );

  return (
    <>
      {groupForPerson && (
        <Box component="form">
          <Dialog
            open={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="lg"
          >
            <DialogTitle id="alert-dialog-title">
              {t("group.history")}
            </DialogTitle>
            <DialogContent>
              {groupForPerson.content.length !== 0 ? (
                <Table>
                  <Head />
                  <TableBody>
                    {groupForPerson.content.map((action: any) => (
                      <Row key={action.id} action={action} />
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>{t("group.noGroupHistory")}</Typography>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                onClick={() => dispatch({ type: "MODAL_CANCEL" })}
              >
                {t("cancel")}
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}
    </>
  );
}
